export default {
  gutter: 20,
  setGutter (val) {
    this.gutter = val
  }
}
